// extracted by mini-css-extract-plugin
export default {"card":"AfaAvisosTerminisCard_card__tTN+n"};